import { createFileRoute } from "@tanstack/react-router";
import { StudyAbroadPage } from "@/components/abroad/StudyAbroadPage";
import { abroadHead } from "@/components/abroad/abroad-head";
import { getEduCountriesCount, type CountriesHead } from "@/lib/edu-countries-count.functions";

// Лендинг «Учёба за рубежом» (en). Адреса трёх языков — ABROAD_PATH.
export const Route = createFileRoute("/en/study-abroad")({
  // Число открытых стран — для FAQ («в подборе N стран») и его JSON-LD. Сбой — без числа.
  loader: async (): Promise<CountriesHead | null> => {
    try {
      return await getEduCountriesCount();
    } catch {
      return null;
    }
  },
  head: ({ loaderData }) => abroadHead("en", loaderData?.count ?? null),
  component: function Page() {
    const data = Route.useLoaderData();
    return <StudyAbroadPage lang="en" countries={data?.count ?? null} />;
  },
});
